import { Logo } from 'assets/Logo';
import { StyledLogoWrapper } from './StyledComponents';

export const LogoItem: React.FC<React.HTMLAttributes<HTMLElement>> = (props) => {
	return (
		<StyledLogoWrapper {...props}>
			<Logo />
		</StyledLogoWrapper>
	);
};
